import React, { Component } from 'react';
import './ProgramItem.css';

export class ProgramItem extends Component {
  render() {
    return <div className="clearfix programItem">
      <p className="pull-left programItem-leftText">
        <strong>{this.props.leftText}</strong>
      </p>
      <p className="pull-right programItem-rightText linebreak">
        {getRightText(this.props.rightText)}
      </p>
      </div>;
  }
}

function getRightText(rightText) {
  if (rightText.indexOf('#') === 0)
  {
    let hymnNumber = +rightText.replace(/[^0-9]/g, '');
    var urlString = rightText.replace(/\s+/g, '-');
    urlString = urlString.replace(/[\s.;,#'%0-9]/g, "");
    urlString = urlString.replace(/’/g, "");
    urlString = urlString.substring(urlString.indexOf('-') + 1).toLowerCase();
    let href = "https://www.churchofjesuschrist.org/study/manual/hymns/";
    if (hymnNumber > 1000) {
      //href for hymns—for home and church
      href = "https://www.churchofjesuschrist.org/study/music/hymns-for-home-and-church/";
    }
    return <a href={href + urlString + "?lang=eng"}>{rightText}</a>;
  }
  return rightText;
}
  
